export default __webpack_public_path__ + "a304f47d43cb9a80357d3ed0b68fea0b.svg";